var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"MenuItem"},[(_vm.type==='router-link')?_c('router-link',{class:{'active': _vm.isActive},attrs:{"to":{name: _vm.routeName}}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.routeName}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }